/* RESPONSIBLE TEAM: team-automation-foundations */
import type DisableComposer from 'embercom/models/operator/visual-builder/step/disable-composer';
import StepConfig, { type StepConfigParams } from '../step';

export default class DisableComposerConfiguration extends StepConfig {
  declare step: DisableComposer;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/disable-composer',
      ...params,
    });
  }
}
